<template>
    <div>
        <p style="text-align: center; font-size: 16px"><b>Bulk Messaging</b></p>
        <p
            v-if="value.state == 'opt-out'"
        >
            You have been opted in to bulk messaging.
        </p>
        <p
            v-else
        >
            You have been opted out of bulk messaging.
        </p>
    </div>
</template>

<script>


export default {
    props: {
        value: {
            type: Object,
            default: function () {
                return {};
            }
        },
    },

    methods: {
        has(value)
        {
            if ( value == null ) return false;
            if ( typeof value === 'string' && value.trim().length == 0 ) return false;
            return true;
        }
    },
}
</script>


<style lang="scss" scoped>

</style>